import axios from 'axios';
import Store from '../admin/store';

const DEFAULT_API_VERSION = 'v1',
	TOKEN_HEADER_NAME = 'x-access-token',
	instance = axios.create({
		timeout: 15000,
		headers: {
			post: {
				'Content-Type': 'multipart/form-data'
			},
			put: {
				'Content-Type': 'application/json'
			},
			patch: {
				'Content-Type': 'application/json'
			}
		}
	});

export function useHttpClient(apiVersion = DEFAULT_API_VERSION) {
	instance.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api/${apiVersion}`;

	return instance;
}

instance.interceptors.request.use(
	config => {
		if (Store.state.token) {
			config.headers.Authorization = `Bearer ${Store.state.token}`;
		}

		return config;
	},
	error => {
		console.error(error);
	}
);

export function attachResponseInterceptor(onSuccess, onFailure) {
	return instance.interceptors.response.use(response => {
		const result = onSuccess(response, response.headers[TOKEN_HEADER_NAME]);

		return result ?? response;
	}, onFailure);
}

export function detachResponseInterceptor(identifier) {
	instance.interceptors.response.eject(identifier);
}
